import getSystemTimezoneOffset from './getSystemTimezoneOffset';

function getSystemTimezoneString() {
  const offset = getSystemTimezoneOffset();
  const absoluteOffset = Math.abs(offset);

  const direction = offset >= 0 ? '+' : '-';
  const hours = String(Math.floor(absoluteOffset / 60)).padStart(2, '0');
  const minutes = String(absoluteOffset % 60).padStart(2, '0');
  return `GMT${direction}${hours}:${minutes}`;
}

export default getSystemTimezoneString;
